import { verbiage } from "./payouts-report-verbiage";

const headerCells = [
  { id: 'payoutAmount', label: verbiage.fieldAmount, sortBy: 'PAYOUT_AMOUNT' },
  { id: 'locationName', label: verbiage.fieldLocation, sortBy: 'LOCATION_NAME' },
  { id: 'createdOn', label: verbiage.fieldPayoutInitiated, sortBy: 'CREATED_ON' },
  { id: 'completedOn', label: verbiage.fieldPayoutCompleted, sortBy: 'COMPLETED_ON' },
  { id: 'status', label: verbiage.fieldStatus, sortBy: 'STATUS' },
];

const groupSummaryFields = [
  {
    title: verbiage.summaryTotalPayouts,
    value: 0,
  },
  {
    title: verbiage.summaryPayoutsCount,
    value: 0,
  },
  {
    title: verbiage.summaryTransactionCount,
    value: 0,
  },
];

export {
    headerCells,
    groupSummaryFields
}